import { createContext } from 'react';

import { localhostDefaultConfig } from './localhostDefaultConfig';

export const BackendConfigContext = createContext(localhostDefaultConfig);
